/* tslint:disable */
/* eslint-disable */
/**
 * Registration App Tier Micro Service APIs
 * Registration App Tier Micro Service APIs
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DocumentImageDataWithType } from './DocumentImageDataWithType';
import {
    DocumentImageDataWithTypeFromJSON,
    DocumentImageDataWithTypeFromJSONTyped,
    DocumentImageDataWithTypeToJSON,
} from './DocumentImageDataWithType';

/**
 * 
 * @export
 * @interface PersonalId
 */
export interface PersonalId {
    /**
     * alphanumeric number - for ex alphanumeric for cid, passportnumber
     * @type {string}
     * @memberof PersonalId
     */
    recordNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalId
     */
    recordType?: PersonalIdRecordTypeEnum;
    /**
     * base64 encoded image data for validation or uploading.
     * @type {string}
     * @memberof PersonalId
     */
    documentData?: string;
    /**
     * base64 encoded image data for validation or uploading.
     * @type {Array<DocumentImageDataWithType>}
     * @memberof PersonalId
     */
    documentDataList?: Array<DocumentImageDataWithType>;
    /**
     * the mime type of the documentData
     * @type {string}
     * @memberof PersonalId
     */
    documentMimeType?: string;
    /**
     * 
     * @type {Date}
     * @memberof PersonalId
     */
    expiryDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PersonalId
     */
    issueDate?: Date;
}


/**
 * @export
 */
export const PersonalIdRecordTypeEnum = {
    Passport: 'PASSPORT',
    Cid: 'CID',
    Ced: 'CED',
    Cex: 'CEX',
    Nit: 'NIT',
    Rif: 'RIF',
    Rut: 'RUT',
    Curp: 'CURP',
    Ppt: 'PPT'
} as const;
export type PersonalIdRecordTypeEnum = typeof PersonalIdRecordTypeEnum[keyof typeof PersonalIdRecordTypeEnum];


/**
 * Check if a given object implements the PersonalId interface.
 */
export function instanceOfPersonalId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PersonalIdFromJSON(json: any): PersonalId {
    return PersonalIdFromJSONTyped(json, false);
}

export function PersonalIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recordNumber': !exists(json, 'recordNumber') ? undefined : json['recordNumber'],
        'recordType': !exists(json, 'recordType') ? undefined : json['recordType'],
        'documentData': !exists(json, 'documentData') ? undefined : json['documentData'],
        'documentDataList': !exists(json, 'documentDataList') ? undefined : ((json['documentDataList'] as Array<any>).map(DocumentImageDataWithTypeFromJSON)),
        'documentMimeType': !exists(json, 'documentMimeType') ? undefined : json['documentMimeType'],
        'expiryDate': !exists(json, 'expiryDate') ? undefined : (new Date(json['expiryDate'])),
        'issueDate': !exists(json, 'issueDate') ? undefined : (new Date(json['issueDate'])),
    };
}

export function PersonalIdToJSON(value?: PersonalId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recordNumber': value.recordNumber,
        'recordType': value.recordType,
        'documentData': value.documentData,
        'documentDataList': value.documentDataList === undefined ? undefined : ((value.documentDataList as Array<any>).map(DocumentImageDataWithTypeToJSON)),
        'documentMimeType': value.documentMimeType,
        'expiryDate': value.expiryDate === undefined ? undefined : (value.expiryDate.toISOString()),
        'issueDate': value.issueDate === undefined ? undefined : (value.issueDate.toISOString()),
    };
}

